
function Information() {
  return (
    <p>
      Experienced Software Developer with a demonstrated history of working in the computer software industry. Skilled in the Python, Javascript, and Solidity programming languages, including the following additional fields of development: NodeJS, Web Development, Decentralized Application Development, Full Stack Development, and Cryptocurrency. Strong engineering professional, currently obtaining my degree, Bachelor of Science - BS focused in Computer Science, from Colorado State University Global.
    </p>
  );
}

export default Information;
